import React, { useEffect, useRef } from "react";
import { graphql, navigate } from "gatsby";
import { Box, Grid, useColorModeValue, Container } from "@chakra-ui/react";
import { Helmet } from "react-helmet";
import Layout from "../components/Layout";
import SearchBox from "../components/SearchBox";
import Item from "../components/Item";

const options = {
  root: null,
  rootMargin: "20px",
  threshold: 1.0,
};

const Index = ({ data, pageContext }) => {
  const loadRef = useRef(null);
  const { nextPagePath } = pageContext;

  const handleObserver = (entities) => {
    const target = entities[0];
    if (target.isIntersecting) {
      if (nextPagePath !== "") {
        navigate(nextPagePath);
      }
    }
  };

  useEffect(function () {
    const observer = new IntersectionObserver(handleObserver, options);
    if (!!loadRef.current) {
      //@ts-ignore
      observer.observe(loadRef?.current);
    }
  }, []);

  const headerBg = useColorModeValue("gray.100", "gray.900");

  return (
    <Layout>
      <Box boxShadow={"0 4px 2px -2px #f3f3f3"} py={2}>
        <Container maxW="container.xl">
          <SearchBox />
        </Container>
      </Box>

      <Box bg={headerBg}>
        <Container maxW="container.xl">
          <Box
            px={4}
            py={{
              base: 6,
              xl: 20,
            }}
          >
            <Box
              as="h1"
              textAlign="center"
              fontWeight="bold"
              fontSize={{
                base: 16,
                xl: 40,
              }}
            >
              Encuentra el meme que se adapte a ti
            </Box>
            <Box
              as="h2"
              textAlign="center"
              fontSize={{
                base: 14,
                xl: 20,
              }}
            >
              Solo memes que merecen estar en tus conversaciones
            </Box>
          </Box>
        </Container>
      </Box>

      <Container maxW="container.xl">
        <Helmet
          htmlAttributes={{
            lang: "es",
          }}
        >
          <title>Momazos</title>
          <meta name="description" content="Busca y encuentra tus memes" />
        </Helmet>

        <Box px={4} mt={4}>
          <Grid
            templateColumns={{
              base: `repeat(1, 1fr)`,
              sm: `repeat(4, 1fr)`,
              xl: `repeat(5, 1fr)`,
            }}
            gap={{
              base: 4,
              xl: 6,
            }}
          >
            {data.momazos.edges.map(({ node }, index) => {
              const loading = index <= 4 ? "eager" : "lazy";

              return <Item node={node} loading={loading} />;
            })}
          </Grid>
        </Box>
        {nextPagePath !== "" && <div ref={loadRef}></div>}
      </Container>
    </Layout>
  );
};

export const pageQuery = graphql`
  query ($limit: Int!) {
    momazos: allAirtable(
      filter: { table: { eq: "Memes" }, data: { Status: { eq: "Active" } } }
      sort: { fields: data___Created, order: DESC }
      limit: $limit
    ) {
      totalCount
      edges {
        node {
          id
          data {
            Name
            tags
            Attachments {
              raw {
                url
              }
              localFiles {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH

                    formats: [AUTO, AVIF, WEBP]
                  )
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default Index;
